import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';

export const Container = styled.div<{ $show: boolean; $offsetY?: number }>`
  width: 100%;
  max-width: max-content;
  position: fixed;
  bottom: ${({ $offsetY }) => ($offsetY ? `${$offsetY}px` : 0)};
  left: 50%;
  z-index: ${Z_INDEX.NOTIFICATION};
  transform: translate(-50%, ${({ $show }) => ($show ? '0' : '100%')});
  transition: 300ms ease-in-out;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};

  @media (max-width: ${CONTAINER_MAX.tabletL}) {
    bottom: 30px;
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    bottom: 15px;
  }
`;
